/*
 * @Author: luoguo
 * @Date: 2024-01-23 10:39:05
 * @LastEditTime: 2024-11-22 10:07:59
 * @LastEditors: luoshoufeng@szkingdom.com
 * @Description:
 */
/*
Author: Liubo
Date: 2018-09-05
Desc: Vuex 状态管理模块-登录状态。同时引入cache模块，当登录状态为true时，设置session缓存和user缓存。当挡路状态为false时，刷新session缓存，清空user缓存
*/
import cache from "@/assets/js/cache";
export default {
    state: {
        status: sessionStorage.getItem("_b") === "1"
    },
    getters: {},
    mutations: {
        SET_STATUS(state, val) {
            state.status = val;
            if (val === true) {
                sessionStorage.setItem("_b", "1");
            } else {
                sessionStorage.removeItem("_b");
            }
        }
    },
    actions: {
        login(context, loginData) {
            return new Promise((resolve, reject) => {
                context.commit("SET_STATUS", true);
                sessionStorage.setItem("alreadyread", "");
                cache.setSession({
                    token: loginData.token,
                    key: loginData.key
                });
                cache.setDesensitization();
                cache.setUser(loginData.userinfo);
                cache.setUserName(loginData.userName);
                cache.queryValidPwdTrdMethod();
                if (loginData.userinfo && loginData.userinfo.isbind === "1") {
                    cache.refresh("_user").then((res) => {
                        cache.setUser(res);
                        const otherUserInfo = cache.getUserOtherInfo().mobileno
                            ? cache.getUserOtherInfo()
                            : loginData.userinfo;
                        otherUserInfo.specialflag = res.specialflag ? res.specialflag : "0";
                        cache.setUserOtherInfo(otherUserInfo);
                        resolve();
                    });
                } else {
                    cache.setUser(loginData.userinfo);
                    resolve();
                }
            });
        },
        logout(context, loginData) {
            return new Promise((resolve, reject) => {
                context.commit("SET_STATUS", false);
                cache.clearUser();
                sessionStorage.removeItem("_a");
                localStorage.removeItem("_a");
                resolve();
                // if (loginData) {
                //     cache.setSession(loginData);
                //     resolve();
                // } else {
                //     cache.setSession();
                //     cache
                //         .refresh("_session")
                //         .then((res) => {
                //             resolve(res);
                //         })
                //         .catch((err) => reject(err));
                // }
            });
        }
    }
};
